import { createFileRoute } from '@tanstack/react-router';

import { RecordingsScreen, validateRecordingsSearch } from '~/pages/recordings';

export const Route = createFileRoute('/_shell/nagrania')({
  // `?klient=<id>` narrows the wall to one client; the slice owns which parameters it understands.
  validateSearch: validateRecordingsSearch,
  component: RecordingsScreen,
});
